import { axios } from '@/utils/request'

const api = {
  param: '/basicdata/param',
  orderType: '/basicdata/orderType',
}

export function getOrderType (parameter) {
  return axios({
    url: api.orderType + '/getOrderType',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function saveClientConfig (parameter) {
  return axios({
    url: api.param + '/saveClientConfig',
    method: 'post',
    data: parameter,
    headers: {
      //'Content-Type': 'application/x-www-form-urlencoded'
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function selectClientOrderConfig (parameter) {
  return axios({
    url: api.param +'/selectClientOrderConfig',
    method: 'get',
    params: parameter
  })
}
//
// export function deleteHelpPic (parameter) {
//   return axios({
//     url: '/basicdata/pic/deleteHelpPic',
//     method: 'get',
//     params: parameter
//   })
// }

export const brandExport = api.brand + '/export'
